import styled from "styled-components"

export const Wrapper = styled.div`
  padding: 0px var(--app-horizontal-padding);
  margin-top: 24px;
`

export const WeightTransitionWrapper = styled.div<{
  $isMaintainWeight: boolean
}>`
  display: flex;
  width: 100%;
  padding: ${(props) => (props.$isMaintainWeight ? "14px 16px" : "16px")};
  justify-content: space-between;
  position: relative;
  overflow: hidden;

  border-radius: 12px;
  border: 1px solid var(--Primitive-White_5, rgba(255, 255, 255, 0.05));
  background: var(--Primitive-White_5, rgba(255, 255, 255, 0.05));
`

export const MeshBackgroundImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  pointer-events: none;
`
export const Label = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  background: var(--white-white-5, rgba(255, 255, 255, 0.05));
  backdrop-filter: blur(60px);

  font-size: 10px;
  font-weight: 700;
  line-height: 160%;
  color: var(--white-white-75, rgba(255, 255, 255, 0.75));
  text-transform: uppercase;
`

export const WeightTransitionImage = styled.img`
  position: absolute;
  top: 16px;
  height: 35px;
  width: 180px;
  object-fit: cover;

  left: 50%;
  transform: translateX(-50%) !important;
`

export const MaintainTitle = styled.div`
  color: var(--Primitive-White_60, rgba(255, 255, 255, 0.6));
  text-align: center;
  font-size: 14px;
  line-height: 24px;
`

export const Weight = styled.span`
  font-size: 28px;
  font-weight: 800;
  line-height: 28px;
`

export const Unit = styled.span`
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
`
